import React from 'react';
// import './App.css';

function Selection() {
  return (
      <div className="Selection">
          <img src="#" className="image"/>
          <p>m, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
          <button> ADD TO CART</button>
      </div>
  );
}

export default Selection;
